import { booleanDuckCreator } from '@atc/modular-redux';
import { pageNames } from '@atc/bonnet-paths';

const showDdpFdpqDuck = booleanDuckCreator({
    store: 'showFdpq',
    initialState: false,
    namespace: pageNames.DEALER_DETAILS,
    storePrefix: `${pageNames.DEALER_DETAILS}.`,
});

export default showDdpFdpqDuck;
